// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__be8J6","row":"styles_row__1IBdD"};